import React, { useEffect, useRef, useLayoutEffect } from "react"
import gsap from "gsap";
import s from "./SplatCanvas.module.scss"
import AssetLoader from "../../../scripts/3d/loaders/AssetLoader";
import frames from "./frames";

export default function Results({ play }) {
  const tl = useRef();
  const splatWrap = useRef(null);
  const splatImage = useRef(null);
  const canvas = useRef(null);
  const context = useRef(null);

  useLayoutEffect(() => {
    context.current = canvas.current.getContext("2d");
    tl.current = gsap.timeline({paused: true, onComplete: () => {
        context.current.clearRect(0, 0, canvas.current.width, canvas.current.height)}
    })
    // drawFrame(1)

    const animation = {
      frame: 1,
    }

    tl.current.fromTo(
      animation,
      {
        frame: 0,
      },
      {
        clearProps: 'all',
        frame: 65,
        duration: 1.5,
        ease: 'none',
        onStart: () => {
          drawFrame(0)
        },
        onUpdate: (self) => {
          drawFrame(Math.floor(animation.frame))
        },
      },
    )

    context.current.clearRect(0, 0, canvas.current.width, canvas.current.height)
  }, []);

  useEffect(() => {
    if (!play) return

    tl.current.restart(0)
  }, [play])

  function drawFrame(number) {
    context.current.clearRect(0, 0, canvas.current.width, canvas.current.height)
    context.current.drawImage(AssetLoader.getImage(frames[number]), 0, 0, 1000, 1000);
  }

  return (
    <div className={s.splatWrap} ref={splatWrap}>
      <canvas ref={canvas} className={s.splat} width="1000" height="1000" />
    </div>
  )
}
